/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
import React, { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { get } from 'lodash';

import axios from '../../services/axios';
import ProductNameSearch from '../../components/ProductNameSearch';

// ⚠️ Ajuste o caminho/nome desses imports conforme seu DS

import { Container } from '../../styles/layout/Container';

import {
   PageHeader,
   PageHeaderText,
   PageSubtitle,
   PageTitle,
} from '../../styles/layout/PageHeader';
import { Section } from '../../styles/layout/Section';
import { FormGrid } from '../../styles/layout/FormGrid';
import { Field } from '../../styles/forms/Field';
import { TableWrapper } from '../../styles/table/TableWrapper';
import { EmptyState } from '../../styles/feedback/EmptyState';
import Loading from '../../components/Loading';
import { Table } from '../../styles/table/Table';
import {
   CardGrid,
   MiniCard,
   MiniCardTitle,
   MiniCardValue,
} from '../../styles/layout/CardGrid';

export default function ProdQuery() {
   const [productQuery, setProductQuery] = useState('');
   const [selectedProduct, setSelectedProduct] = useState(null);

   const [isLoading, setIsLoading] = useState(false);
   const [product, setProduct] = useState(null);
   const [stock, setStock] = useState([]);

   const selectedSku = useMemo(() => {
      if (selectedProduct?.prod_sku) return String(selectedProduct.prod_sku);

      // fallback: caso o displayMode seja "sku-name"
      const raw = String(productQuery || '').trim();
      const m = raw.match(/^(\d{7})\b/);
      return m?.[1] || '';
   }, [selectedProduct, productQuery]);

   const canSearch = Boolean(selectedSku);

   const handleSubmit = async (e) => {
      e.preventDefault();

      if (!selectedSku) {
         toast.error('Selecione um produto na lista para pesquisar o estoque.');
         return;
      }

      try {
         setIsLoading(true);

         const response = await axios.get(`stock/${selectedSku}`);
         setProduct(response.data.prod || null);
         setStock(response.data.stock || []);
      } catch (err) {
         const errors = get(err, 'response.data.errors', []);
         if (errors.length) errors.forEach((msg) => toast.error(msg));
         else toast.error('Erro ao consultar estoque.');
      } finally {
         setIsLoading(false);
      }
   };

   return (
      <Container>
         {/* Header */}
         <PageHeader>
            <PageHeaderText>
               <PageTitle>Pesquisa de estoque disponível</PageTitle>
               <PageSubtitle>
                  Consulte a quantidade disponível do produto por ponto de
                  venda.
               </PageSubtitle>
            </PageHeaderText>
         </PageHeader>

         {/* Pesquisa */}
         <Section title="Pesquisa">
            <form onSubmit={handleSubmit}>
               <FormGrid>
                  {/* COLUNA 1 (≈60%) */}
                  <Field $col={5} $colMobile={12} label="Produto (SKU ou nome)">
                     <label>Produto (SKU ou nome)</label>
                     <ProductNameSearch
                        value={productQuery}
                        onChange={setProductQuery}
                        onSelect={(p) => {
                           setSelectedProduct(p || null);
                           if (!p) {
                              setProduct(null);
                              setStock([]);
                           }
                        }}
                        nameLike={false}
                        displayMode="sku-name"
                        placeholder="Digite o SKU ou o nome e selecione o produto..."
                     />
                        <button
                           type="submit"
                           disabled={!canSearch || isLoading}
                        >
                           Pesquisar
                        </button>
                  </Field>

                  {/* COLUNA 2 (≈40%) */}
                  <Field $col={7} $colMobile={12} label="&nbsp;">
                     {!product?.id ? (
                        <EmptyState
                           title="Selecione um produto"
                           description="Digite o SKU ou o nome e escolha um item na lista para visualizar os dados."
                        />
                     ) : (
                        <>
                           {/* Linha 1: ID + SKU */}
                           <CardGrid
                              $span={12}
                              $mdSpan={6}
                              $lgSpan={6}
                              style={{ marginBottom: 12 }}
                           >
                              <MiniCard>
                                 <MiniCardTitle>ID</MiniCardTitle>
                                 <MiniCardValue>{product.id}</MiniCardValue>
                              </MiniCard>

                              <MiniCard>
                                 <MiniCardTitle>SKU</MiniCardTitle>
                                 <MiniCardValue>
                                    {product.prod_sku}
                                 </MiniCardValue>
                              </MiniCard>
                           </CardGrid>

                           {/* Linha 2: Nome full */}
                           <CardGrid $span={12} $mdSpan={12} $lgSpan={12}>
                              <MiniCard>
                                 <MiniCardTitle>Produto</MiniCardTitle>
                                 <MiniCardValue
                                    style={{ fontSize: 16, lineHeight: 1.2 }}
                                 >
                                    {product.prod_name}
                                 </MiniCardValue>
                              </MiniCard>
                           </CardGrid>
                        </>
                     )}
                  </Field>
               </FormGrid>
            </form>
         </Section>

         {/* Resultados */}
         <Section
            title="Resultados"
            // opcional: se você quiser mostrar meta no header, dá pra usar o SectionMeta aqui
         >
            {isLoading ? <Loading /> : null}

            {!product?.id ? (
               <EmptyState
                  title="Nenhum resultado"
                  description="Selecione um produto e clique em “Pesquisar” para ver o estoque disponível."
               />
            ) : stock.length === 0 ? (
               <EmptyState
                  title="Sem estoque disponível"
                  description="Não há saldo disponível para este produto nos pontos de venda consultados."
               />
            ) : (
               <TableWrapper>
                  <Table>
                     <thead>
                        <tr>
                           <th style={{ width: '80%', textAlign: 'left' }}>
                              Ponto de venda
                           </th>
                           <th style={{ textAlign: 'center' }}>
                              Quantidade disp.
                           </th>
                        </tr>
                     </thead>
                     <tbody>
                        {stock.map((row) => (
                           <tr key={String(row.id)}>
                              <td>{row.pdv_name}</td>
                              <td style={{ textAlign: 'center' }}>
                                 {row.stock_qtd}
                              </td>
                           </tr>
                        ))}
                     </tbody>
                  </Table>
               </TableWrapper>
            )}
         </Section>
      </Container>
   );
}
